// extracted by css-extract-rspack-plugin
export default {"container":"_f72ffe3a","text":"_16696960","collection":"_664d9aab"};